var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 13.1667H3.33333V5.83341H12.6667M10.6667 1.16675V2.50008H5.33333V1.16675H4V2.50008H3.33333C2.59333 2.50008 2 3.09341 2 3.83341V13.1667C2 13.5204 2.14048 13.8595 2.39052 14.1096C2.64057 14.3596 2.97971 14.5001 3.33333 14.5001H12.6667C13.0203 14.5001 13.3594 14.3596 13.6095 14.1096C13.8595 13.8595 14 13.5204 14 13.1667V3.83341C14 3.47979 13.8595 3.14065 13.6095 2.89061C13.3594 2.64056 13.0203 2.50008 12.6667 2.50008H12V1.16675M11.3333 8.50008H8V11.8334H11.3333V8.50008Z",
    fill: "#9BA4AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar_icon.1b2bdee2b21dd389b8ba143b194a8f30.svg";
export { ForwardRef as ReactComponent };